// extracted by mini-css-extract-plugin
export default {"root":"PizzaError_root__pnrQd"};